var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollegeVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5625V14.5313C0 14.7902 0.212562 15 0.475 15H2.85V5.625H0.95C0.425422 5.625 0 6.04483 0 6.5625ZM10.6875 5.15625H9.975V3.98438C9.975 3.85489 9.86872 3.75 9.7375 3.75H9.2625C9.13128 3.75 9.025 3.85489 9.025 3.98438V5.85938C9.025 5.98887 9.13128 6.09375 9.2625 6.09375H10.6875C10.8187 6.09375 10.925 5.98887 10.925 5.85938V5.39063C10.925 5.26113 10.8187 5.15625 10.6875 5.15625ZM14.777 3.28242L10.027 0.157327C9.87087 0.0547383 9.68753 0 9.5 0C9.31247 0 9.12913 0.0547383 8.97305 0.157327L4.22305 3.28242C4.09294 3.36802 3.98626 3.48399 3.91246 3.62003C3.83866 3.75608 3.80003 3.908 3.8 4.06231V15H7.6V10.7813C7.6 10.5223 7.81256 10.3125 8.075 10.3125H10.925C11.1874 10.3125 11.4 10.5223 11.4 10.7813V15H15.2V4.0626C15.2 3.74912 15.0412 3.45615 14.777 3.28242ZM9.5 7.5C8.18841 7.5 7.125 6.45059 7.125 5.15625C7.125 3.86192 8.18841 2.8125 9.5 2.8125C10.8116 2.8125 11.875 3.86192 11.875 5.15625C11.875 6.45059 10.8116 7.5 9.5 7.5ZM18.05 5.625H16.15V15H18.525C18.7874 15 19 14.7902 19 14.5313V6.5625C19 6.04483 18.5746 5.625 18.05 5.625Z",
    fill: "#103A50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeVector);
export default __webpack_public_path__ + "static/media/CollegeVector.6473c40ed3b74abb3e451efa6f274831.svg";
export { ForwardRef as ReactComponent };